import React from "react";
import Badge1 from "../../../assets/img/tentang-kami/star-badge.svg";
import Badge2 from "../../../assets/img/tentang-kami/gross-margin.svg";
import Badge3 from "../../../assets/img/tentang-kami/growth-chart.svg";

function MengapaMemilihDanai() {
    return (
        <>
            <div className="container-mengapa-memilih-kami">
                <h2>Mengapa Memilih Kami</h2>
                <div className="all-card">
                    <div className="card">
                        <img src={Badge1} alt="Badge 1"/>
                        <p>
                            <strong>Pelayanan Terbaik</strong><br/>
                            Danai.id berkomitmen memberikan pelayanan terbaik bagi Anda, baik sebagai Peminjam maupun
                            Pemberi Pinjaman.
                            Karena kepuasan dan kepercayaan Anda adalah prioritas kami.
                        </p>
                    </div>
                    <div className="card">
                        <img src={Badge2} alt="Badge 2"/>
                        <p>
                            <strong>Profesional</strong><br/>
                            Danai.id mengaplikasikan praktik industri terbaik dalam setiap aspek layanan untuk memastikan pengelolaan
                            keuangan Anda berlangsung transparan, aman, dan efisien.
                        </p>
                    </div>
                    <div className="card">
                        <img src={Badge3} alt="Badge 3"/>
                        <p>
                            <strong>Imbal Hasil Menarik</strong><br/>
                            Danai.id memberi kesempatan kepada Pemberi Pinjaman, untuk memperoleh imbal hasil yang kompetitif dengan
                            tingkat risiko yang terukur dan dikelola secara profesional.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MengapaMemilihDanai;